import { render, staticRenderFns } from "./DpcQuart.vue?vue&type=template&id=79bdaea7&"
import script from "./DpcQuart.vue?vue&type=script&lang=ts&"
export * from "./DpcQuart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports